import * as ACTIONTYPE from '../constants/actiontypes'

const _default = {
    textAreaPage: 1,
    isSlideZoomed: false,
    isReady: false,
    theme: 'theme-black',
    textHeight: 130
};

export default function (state = _default, action) {
    let newVal;
    switch (action.type) {
        case ACTIONTYPE.NEXT_TEXT_AREA_PAGE:
            newVal = state.textAreaPage + 1;
            return { ...state, textAreaPage: newVal };
        case ACTIONTYPE.PREV_TEXT_AREA_PAGE:
            newVal = state.textAreaPage - 1;
            return { ...state, textAreaPage: newVal };
        case ACTIONTYPE.CHANGE_TEXT_AREA_PAGE:
            newVal = action.page;
            return { ...state, textAreaPage: newVal, textAreaPages: action.pages };
        case ACTIONTYPE.TEXT_PLAYER_CHANGE_THEME:
            return { ...state, theme: action.data };
        case ACTIONTYPE.TOGGLE_ZOOM_AREA:
            return { ...state, isSlideZoomed: !state.isSlideZoomed };
        case ACTIONTYPE.SET_TEXT_HEIGHT:
            return { ...state, textHeight: action.data };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/TextPlayerReducer.js